import React, { memo, useMemo } from 'react';

import scss from './UserProfile.module.scss';

const UserAvatar = ({ name = '' }) => {
  const mainWord = useMemo(() => name[0]?.toUpperCase(), [name]);

  return <div className={scss.userAvatar}>{mainWord}</div>;
};

export default memo(UserAvatar);
